import React from 'react'
import styled from 'styled-components'
import { Spinner } from 'reactstrap'

const Container = styled.div`
  text-align: center;
  .spinner-grow {
    width: 3rem !important;
    height: 3rem !important;
    margin-left: 10px;
    margin-bottom: 20px;
  }
  .spinner-grow:first-child {
    margin-left: 0;
  }
`

export default function Loader() {
  return (
    <Container className="col-sm-12">
      <Spinner type="grow" color="dark" />
      <Spinner type="grow" color="dark" />
      <Spinner type="grow" color="dark" />
      <Spinner type="grow" color="dark" />
    </Container>
  )
}
